module.exports = __webpack_public_path__ + "static/img/remark-content.ab94021.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/remark-content.png
// module id = Ycs1
// module chunks = 1